import type { JSX } from 'react'
import type { FallbackImageSizes } from 'atoms/FallbackImage/FallbackImage.h'
import type { IconNames, IconQualitySizes, IconSocialSizes } from './Icon.h'

import { IconSizes, IconsMap } from './Icon.h'
import { IconSC } from './Icon.styled'

export interface IIconProps {
  name: IconNames
  size?:
    | IconSizes
    | FallbackImageSizes
    | IconSocialSizes
    | IconQualitySizes
    | null
  color?: string
  filled?: boolean
  className?: string
  height?: IconSizes | null
}

export const Icon = ({
  name,
  size = IconSizes.medium,
  height,
  color,
  filled,
  className,
}: IIconProps): JSX.Element => {
  const IconSymbol = IconsMap[name]
  return (
    <IconSC
      size={size}
      iconHeight={height}
      colorDefault={color}
      className={className!}
    >
      <IconSymbol filled={filled} />
    </IconSC>
  )
}
